import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, Facebook } from 'lucide-react';
import { CONTACT_INFO, NAVIGATION } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: 'var(--velora-green-deep)' }}>
      <div className="container-luxury pt-16 pb-12 md:py-16 px-6 md:px-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-5">
            <Link 
              to="/" 
              className="font-display text-2xl font-light tracking-tight mt-3 md:mt-0 mb-6 block"
              style={{ color: 'var(--velora-champagne)' }}
            >
              Velora Marketing
            </Link>
            <p 
              className="text-sm leading-relaxed mb-6 max-w-sm"
              style={{ color: 'rgba(245, 240, 230, 0.5)', fontFamily: 'Inter, sans-serif' }}
            >
              Shaping perception, influence, and growth for iconic brands, institutions, and
              leaders worldwide.
            </p>
            <div className="divider-gold opacity-30" />
          </div>

          {/* Navigation Column */}
          <div className="md:col-span-3 md:col-start-7">
            <h4
              className="text-xs font-medium tracking-widest uppercase mb-5"
              style={{ color: 'var(--velora-gold)', fontFamily: 'Inter, sans-serif' }}
            >
              Navigation
            </h4>
            <nav className="space-y-3">
              {NAVIGATION.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="block text-sm transition-colors duration-400"
                  style={{ color: 'rgba(245, 240, 230, 0.5)', fontFamily: 'Inter, sans-serif' }}
                  onMouseEnter={(e) => e.target.style.color = 'var(--velora-gold)'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(245, 240, 230, 0.5)'}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-4">
            <h4
              className="text-xs font-medium tracking-widest uppercase mb-5"
              style={{ color: 'var(--velora-gold)', fontFamily: 'Inter, sans-serif' }}
            >
              Connect
            </h4>
            <div className="space-y-3">
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                className="block text-sm transition-colors duration-400"
                style={{ color: 'rgba(245, 240, 230, 0.5)', fontFamily: 'Inter, sans-serif' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--velora-gold)'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(245, 240, 230, 0.5)'}
              >
                {CONTACT_INFO.email}
              </a>
              <a
                href={`tel:${CONTACT_INFO.phone}`}
                className="block text-sm transition-colors duration-400"
                style={{ color: 'rgba(245, 240, 230, 0.5)', fontFamily: 'Inter, sans-serif' }}
                onMouseEnter={(e) => e.target.style.color = 'var(--velora-gold)'}
                onMouseLeave={(e) => e.target.style.color = 'rgba(245, 240, 230, 0.5)'}
              >
                {CONTACT_INFO.phone}
              </a>
              <p 
                className="text-sm"
                style={{ color: 'rgba(245, 240, 230, 0.3)', fontFamily: 'Inter, sans-serif' }}
              >
                {CONTACT_INFO.office}
              </p>
              
              {/* Social Media Icons */}
              <div className="flex items-center space-x-4 pt-4">
                <a
                  href="https://www.linkedin.com/company/velora-branding-marketing-agency/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="transition-opacity duration-300 hover:opacity-100"
                  style={{ color: 'rgba(245, 240, 230, 0.5)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--velora-gold)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(245, 240, 230, 0.5)'}
                >
                  <Linkedin size={16} strokeWidth={1.5} />
                </a>
                <a
                  href="https://www.instagram.com/veloramarketingagency"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="transition-opacity duration-300 hover:opacity-100"
                  style={{ color: 'rgba(245, 240, 230, 0.5)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--velora-gold)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(245, 240, 230, 0.5)'}
                >
                  <Instagram size={16} strokeWidth={1.5} />
                </a>
                <a
                  href="https://www.facebook.com/share/1BgYZRv7TA/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="transition-opacity duration-300 hover:opacity-100"
                  style={{ color: 'rgba(245, 240, 230, 0.5)' }}
                  onMouseEnter={(e) => e.currentTarget.style.color = 'var(--velora-gold)'}
                  onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(245, 240, 230, 0.5)'}
                >
                  <Facebook size={16} strokeWidth={1.5} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div 
          className="mt-12 pt-6"
          style={{ borderTop: '1px solid rgba(245, 240, 230, 0.08)' }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <p 
              className="text-xs"
              style={{ color: 'rgba(245, 240, 230, 0.25)', fontFamily: 'Inter, sans-serif' }}
            >
              © {currentYear} Velora Marketing. All rights reserved.
            </p>
            <p 
              className="text-xs"
              style={{ color: 'rgba(245, 240, 230, 0.25)', fontFamily: 'Inter, sans-serif' }}
            >
              Global Branding & Growth Authority
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
